var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"text-overflow",style:({'width': _vm.width}),attrs:{"title":_vm.overflowTitle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }